import api from '@/api'

const { $messages } = api;

export const { $templates, $workflowAreas} = $messages;